import { AxiosRequestConfig } from 'axios';
import {
  transformPartnersTypeaheadResponse,
  transformUsersTypeaheadResponse,
} from './response';
import { UsersTypeaheadFilterType } from './types';

export const getFetchUsersConfig = (
  value: string,
  options: Partial<AxiosRequestConfig> = {},
  filters: Partial<UsersTypeaheadFilterType> = {}
): AxiosRequestConfig => ({
  method: 'POST',
  data: {
    filters: {
      nameOrEmail: value,
      ...filters,
    },
  },
  transformResponse: transformUsersTypeaheadResponse,
  ...options,
});

export const getFetchPartnersConfig = (value: string): AxiosRequestConfig => ({
  method: 'POST',
  url: '/partners',
  data: {
    filters: {
      name: value,
    },
  },
  transformResponse: transformPartnersTypeaheadResponse,
});
